module.exports = __webpack_public_path__ + "components/forecast-table/static/freezing-graph_backdrop-snow-4de4387d27ad6336a9ea8426d9c327db.png";